import { useLogout } from "@/authentication/useLogout";
import type { ContextMenuItem } from "@/components/ContextMenu/ContextMenu";
import { ContextMenu } from "@/components/ContextMenu/ContextMenu";
import { LogOut01Icon } from "@/components/Icons/LogOut01Icon";
import { ProjectLogo } from "@/components/ProjectLogo/ProjectLogo";
import { UserAvatar } from "@/components/UserAvatar/UserAvatar";
import { Button } from "@/design-system/Button";
import { Inline } from "@/design-system/Inline";
import { Text } from "@/design-system/Text";
import { useSessionUserOptional } from "@/hooks/Network/useSessionUser";
import { useTranslation } from "@/translations";

import { OnboardingFlowBrandMark, OnboardingFlowHeader } from "./OnboardingFlowLayout";

export function OnboardingTopBar(): React.ReactNode {
  const { t } = useTranslation();
  const logout = useLogout();
  const [sessionUser] = useSessionUserOptional();

  const menuItems: ContextMenuItem[] = [
    {
      labels: { default: t("component.user-menu.log-out") },
      value: "logout",
      icon: <LogOut01Icon />,
      callbackFn: () => logout(),
    },
  ];

  return (
    <OnboardingFlowHeader
      brand={
        <Inline gap="sm" align="center" wrap={false}>
          <OnboardingFlowBrandMark>
            <ProjectLogo src={sessionUser?.project?.logoUrl} />
          </OnboardingFlowBrandMark>
          <Text variant="body-emphasis">{sessionUser?.project?.name}</Text>
        </Inline>
      }
      action={
        <ContextMenu
          items={menuItems}
          triggerComponent={
            <Button variant="subtle">
              <UserAvatar size="sm" image={sessionUser?.avatar} />
              <span className="hidden @sm:block">
                <Text align="start">{sessionUser?.fullName || t("component.user-menu.menu")}</Text>
              </span>
            </Button>
          }
        />
      }
    />
  );
}
